import { USER_TYPES } from '../context/AuthContext';

// Permission checks for different user types
export const canWrite = (userType) => {
  return userType === USER_TYPES.JOURNALIST || userType === USER_TYPES.ADMIN;
};

export const canBookmark = (userType) => {
  return userType === USER_TYPES.READER || userType === USER_TYPES.JOURNALIST || userType === USER_TYPES.ADMIN;
};

export const canSubscribe = (userType) => {
  return userType === USER_TYPES.READER || userType === USER_TYPES.JOURNALIST || userType === USER_TYPES.ADMIN;
};

export const canComment = (userType) => {
  return userType === USER_TYPES.READER || userType === USER_TYPES.JOURNALIST || userType === USER_TYPES.ADMIN;
};

export const canEditProfile = (userType) => {
  return userType === USER_TYPES.READER || userType === USER_TYPES.JOURNALIST || userType === USER_TYPES.ADMIN;
};

// Admin-specific permission
export const canAccessAdminPanel = (userType) => {
  return userType === USER_TYPES.ADMIN;
};

// Helper to check if user is authenticated
export const isAuthenticated = (userType) => {
  return userType !== USER_TYPES.ANONYMOUS;
};